// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["clock"]
  static values = {
    slatitle: String,
    dispendtime: String,
    endtime: String,
    parsedEndtime: Number,
  }

  connect() {
    this.parsedEndtimeValue = Date.parse(this.endtimeValue)
    this.initializeClock()
  }

  getTimeRemaining() {
    const tn = Date.parse(new Date())
   
    // negative is overdue
    const delta = this.parsedEndtimeValue - tn

    const seconds = Math.floor( (delta / 1000) % 60)
    const minutes = Math.floor( (delta / 1000 / 60) % 60)
    const hours = Math.floor( (delta / (1000 * 60 * 60)) % 24)
    const days= Math.floor( (delta / (1000*60*60*24) ))

    return {
      delta, 
      days,
      hours,
      minutes,
      seconds,
    }
  }

  formatClock(time) {
    let message =""
    if (time.days == 0) {
      if( time.hours == 0) {
        if (time.minutes  < 15) {
          message = `<div class="alert alert-warning small m-1"><span class="fas fa-alarm-exclamation"></span> ${this.slatitleValue}<div class="font-weight-bold d-block text-nowrap text-danger"><span class="m">${time.minutes}</span><span class="s">${time.seconds}</span></div></div>`
        }
        else {
          message = `<div class="alert alert-warning small m-1"><span class="fas fa-alarm-exclamation"></span> ${this.slatitleValue}<div class="font-weight-bold d-block text-nowrap"><span class="m">${time.minutes}</span><span class="s">${time.seconds}</span></div></div>`
        }
      }
      else {
        if (time.hours == 1) {
          message = `<div class="alert alert-warning small m-1"><span class="fas fa-alarm-clock"></span> ${this.slatitleValue}<div class="font-weight-bold d-block text-nowrap"><span class="h">${time.hours}</span><span class="m">${time.minutes}</span><span class="s">${time.seconds}</span></div></div>`
        }
        else {
          message = `<div class="alert alert-light small m-1"><span class="fas fa-alarm-clock"></span> ${this.slatitleValue}<div class="font-weight-bold d-block text-nowrap"><span class="h">${time.hours}</span><span class="m">${time.minutes}</span><span class="s">${time.seconds}</span></div></div>`
        }
      }
    }
    else {
      message = `<div class="alert alert-dark small m-1"><span class="fas fa-alarm-clock"></span> ${this.slatitleValue}<div class="font-weight-bold d-block text-nowrap">${this.dispendtimeValue}</div></div>`
    }
    return message
  }

  displayClock = ()  => {
    const sla = this.getTimeRemaining()
    if(sla.delta < 0) {
      this.clockTarget.innerHTML = `<div class="alert alert-danger small m-1"><span class="fas fa-exclamation-triangle"></span>${this.slatitleValue}<div class="font-weight-bold d-block text-nowrap">${this.dispendtimeValue}</div></div>`   
      clearInterval(this.timeinterval)
    }
    else {
      this.clockTarget.innerHTML = this.formatClock(sla)
    }
  }

  initializeClock() {
    this.displayClock();
    this.timeinterval = setInterval( this.displayClock ,1000)
  }

}
